"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageContentBySourceList = void 0;

var basic_frontend_common_1 = require("basic-frontend-common");

var react_1 = __importStar(require("react"));

var react_localization_1 = __importDefault(require("react-localization"));

var components_1 = require("../../../components");

var compositions_1 = require("../../../compositions");

var service_clients_1 = require("../../../service-clients");

var json = __importStar(require("./localization.json"));

var PageContentBySourceList = function PageContentBySourceList(_a) {
  var theme = _a.theme,
      language = _a.language,
      sourceId = _a.sourceId,
      _b = _a.userIsLoggedIn,
      userIsLoggedIn = _b === void 0 ? false : _b;
  var localizedStrings = new react_localization_1["default"](json);
  localizedStrings.setLanguage(language);

  var _c = __read((0, react_1.useState)(), 2),
      limitReached = _c[0],
      setLimitReached = _c[1];

  var _d = __read((0, react_1.useState)(null), 2),
      sourceState = _d[0],
      setSourceState = _d[1];

  var _e = __read((0, react_1.useState)(""), 2),
      titleState = _e[0],
      setTitleState = _e[1];

  var loadSource = function loadSource() {
    (0, service_clients_1.getArchiveSourceAggregateById)(sourceId).then(function (res) {
      return setSourceState(res);
    });
  };

  (0, react_1.useEffect)(function () {
    loadSource();
  }, []);
  (0, react_1.useEffect)(function () {
    var title = sourceState && localizedStrings.formatString(localizedStrings.sharedContent.pages.pageContentBySourceList.title, sourceState.sourceName).toString();
    setTitleState(title);
  }, [sourceState]);
  return react_1["default"].createElement(basic_frontend_common_1.ContainerArticle, {
    theme: theme
  }, react_1["default"].createElement(basic_frontend_common_1.Intro, {
    title: titleState,
    lead: localizedStrings.sharedContent.pages.pageContentBySourceList.leadText,
    theme: theme,
    containerContent: true,
    hruler: true,
    marginBottom: false,
    marginTop: false,
    paddingBottom: false
  }), react_1["default"].createElement(basic_frontend_common_1.ContainerSection, {
    theme: theme,
    marginTop: true
  }, react_1["default"].createElement(components_1.SuspenseWrapper, {
    theme: theme
  }, react_1["default"].createElement(components_1.ContentAggregateList, {
    theme: theme,
    limitReached: limitReached,
    onLimitReached: setLimitReached,
    sourceId: sourceId,
    language: language
  }))), react_1["default"].createElement(compositions_1.LimitReached, {
    language: language,
    limitReached: limitReached,
    userIsLoggedIn: userIsLoggedIn
  }));
};

exports.PageContentBySourceList = PageContentBySourceList;